// Sprint 6 HOCH 7 — Fokustyp-Icons (PNG, blau-monochrom, vom Designer geliefert).
// Live unter /icons/ aus dem public-Folder.
import React from "react";

const ICON_BASE = "/icons";

function _PngIcon({ src, alt, size = 40, className = "" }) {
  return (
    <img
      src={src}
      alt={alt}
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      className={className}
      style={{ display: "inline-block", verticalAlign: "middle" }}
      data-testid={`fokustyp-icon-${alt.toLowerCase()}`}
    />
  );
}

export function EuleGlyph({ size = 40, className = "" }) {
  return <_PngIcon src={`${ICON_BASE}/icon-eule.png`} alt="Eule" size={size} className={className} />;
}

export function BieneGlyph({ size = 40, className = "" }) {
  return <_PngIcon src={`${ICON_BASE}/icon-biene.png`} alt="Biene" size={size} className={className} />;
}

export function KatzeGlyph({ size = 40, className = "" }) {
  return <_PngIcon src={`${ICON_BASE}/icon-katze.png`} alt="Katze" size={size} className={className} />;
}

export function HundGlyph({ size = 40, className = "" }) {
  return <_PngIcon src={`${ICON_BASE}/icon-hund.png`} alt="Hund" size={size} className={className} />;
}

// FOKUSTYP_META: deutsche Slugs als Schlüssel (eule/biene/katze/hund)
export const FOKUSTYP_META = {
  eule:  { name: "Eule",  tagline: "WAS + WARUM",   Icon: EuleGlyph,  iconSrc: `${ICON_BASE}/icon-eule.png` },
  biene: { name: "Biene", tagline: "WER + WIE",     Icon: BieneGlyph, iconSrc: `${ICON_BASE}/icon-biene.png` },
  katze: { name: "Katze", tagline: "WIE + WARUM",   Icon: KatzeGlyph, iconSrc: `${ICON_BASE}/icon-katze.png` },
  hund:  { name: "Hund",  tagline: "WER + WIE",     Icon: HundGlyph,  iconSrc: `${ICON_BASE}/icon-hund.png` },
};

// Sprint-V24 Prinzip 2 (Issue S, 11.02.2026) — Fokustyp-Reihenfolge klargestellt.
// Der Audit-Befund „zwei unterschiedliche Reihenfolgen" war formal richtig, aber
// die beiden Konstanten haben ZWEI unterschiedliche Zwecke:
//   • FOKUSTYP_DISPLAY_ORDER (hier)   → reine UI-Anzeigereihenfolge (MiniTest,
//     Fokustyp-Cards, Landing Hero) — Eule → Biene → Katze → Hund.
//   • TIE_BREAK_ORDER (quickTestData.js) → Business-Logic aus v2.5 §4.3.1 FINAL,
//     Tie-Break-Priorität bei Gleichstand — Eule > Biene > Hund > Katze.
// Nicht angleichen ohne Produkt-Freigabe. Alias `FOKUSTYP_ORDER` bleibt fuer
// Backward-Compat der bestehenden Importe (MiniTest, _archive/Landing).
export const FOKUSTYP_DISPLAY_ORDER = ["eule", "biene", "katze", "hund"];
export const FOKUSTYP_ORDER = FOKUSTYP_DISPLAY_ORDER;

// Hilfreich, falls Backend doch englische Keys liefert.
export const ENGLISH_TO_SLUG = { owl: "eule", bee: "biene", cat: "katze", dog: "hund" };
export function normalizeSlug(key) {
  if (!key) return "eule";
  const lk = String(key).toLowerCase();
  return ENGLISH_TO_SLUG[lk] || lk;
}
